module.exports = __webpack_public_path__ + "assets/06d958315fc6cdbb28576b03e43203aa.js";